import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { register } from 'actions/user';
import { setAccessToken } from 'actions/app';
import { REGISTER_FAILURE } from 'types/user';
import { STATUS_FAILURE } from 'types/app';

import Button from 'components/Button';
import Link from 'components/Link';
import Message from 'components/Message';
import { H3, SecondaryHierarchyText } from 'components/Common/Typography';
import { BlockSpace, InlineSpace } from 'components/Common/Spacing';

import { routeToQueryRedirect, setAccessTokenHeader } from 'utils';

import styles from './Register.css';

const ENTER_KEY_CODE = 13;

export default function Register({ title }) {
  useStyles(styles);

  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');

  const { error, registerStatus } = useSelector(state => state.user);

  const postRegister = async () => {
    const registerResponse = await dispatch(
      register({
        email,
        password,
        name,
        username,
      }),
    );

    if (registerResponse.type === REGISTER_FAILURE) {
      return;
    }
    const {
      payload: { accessToken },
    } = registerResponse;
    dispatch(setAccessToken(accessToken));
    setAccessTokenHeader(accessToken);
    routeToQueryRedirect();
  };

  const onKeyDown = event => {
    if (event.keyCode === ENTER_KEY_CODE) {
      return postRegister();
    }
    return null;
  };

  return (
    <div>
      <div className={styles.container}>
        <H3>{title}</H3>
        <BlockSpace size={200} />
        {registerStatus === STATUS_FAILURE && error && (
          <Message messageType="error">{error}</Message>
        )}
        <form>
          <div>
            <label htmlFor="name">
              Name:
              <input
                className={styles.input}
                id="name"
                type="text"
                name="name"
                value={name}
                onChange={e => {
                  setName(e.target.value);
                }}
                onKeyDown={onKeyDown}
              />
            </label>
          </div>
          <BlockSpace size={100} />
          <div>
            <label htmlFor="email">
              Email address:
              <input
                className={styles.input}
                id="email"
                type="email"
                name="email"
                value={email}
                onChange={e => {
                  setEmail(e.target.value);
                }}
                onKeyDown={onKeyDown}
              />
            </label>
          </div>
          <BlockSpace size={100} />
          <div>
            <label htmlFor="username">
              Username:
              <input
                className={styles.input}
                id="username"
                type="text"
                name="username"
                value={username}
                onChange={e => {
                  setUsername(e.target.value);
                }}
                onKeyDown={onKeyDown}
              />
            </label>
          </div>
          <BlockSpace size={100} />
          <div>
            <label htmlFor="password">
              Password:
              <input
                className={styles.input}
                id="password"
                type="password"
                name="password"
                value={password}
                onChange={e => {
                  setPassword(e.target.value);
                }}
                onKeyDown={onKeyDown}
              />
            </label>
          </div>
          <BlockSpace size={100} />
          <div>
            <Button buttonType="primary" onClick={postRegister}>
              Register
            </Button>
          </div>
        </form>
        <BlockSpace size={200} />
        <div>
          <SecondaryHierarchyText>Already registered?</SecondaryHierarchyText>
          <InlineSpace size={25} />
          <Link to="/login">Log in</Link>
        </div>
      </div>
    </div>
  );
}

Register.propTypes = {
  title: PropTypes.string.isRequired,
};
